import {BaseEntityAuditada} from '../models/base-entity-auditada.model';

export interface Parametro extends BaseEntityAuditada {
  nome?: string;
  valor?: string;
}

export enum ParametroVersao {
  CONVERSOR = <any> 'ultimaVersaoConversor',
  EXTRATOR = <any> 'ultimaVersaoExtrator',
  IRIS = <any> 'ultimaVersaoIris',
  PRISMA = <any> 'ultimaVersaoPrisma'
}
